class Notifications {
	constructor(button) {
		this._button = ge(button);

		if (this._button === null) return;
		
		onEv(this._button, 'click', this.showNotifications.bind(this));

		this.countElem = UI.div('notification-count animated norm');
		this._button.appendChild(this.countElem);

		this._list = Dialog.Popup(
			this._listElem = UI.div('notification-list'), 
			'above-start',
			_("NOTIFICATIONS")
		).sticky();

		this.showCount(notificationCount);
	}

	showCount(value) {
		if (0 < value) {
			this.countElem.innerHTML = value;
			state(this.countElem, 'active');
		}
		else {
			state(this.countElem);
		}
	}

	showNotifications() {
		this._list.handle(this._button);
		while (this._listElem.firstChild) this._listElem.removeChild(this._listElem.firstChild);

		API.fetch(
			'notifications'
		)
		.then(reply => {
			if (reply.notifications && Array.isArray(reply.notifications)){
				reply.notifications.forEach(data => {
					let note = Notification.fromData(data, this);
					this._listElem.appendChild(note.elem);
				});
			}
		});
	}

	checkPermission(type) {
		return this._permissions[type] === 1;
	}
}

class Notification {
	static READ = 1;
	static ACCEPT = 2;
	static REJECT = 3;
	static ADMIN = 4;
	static MEMBER = 5;

	static ACTION_LABELS = {
		[this.READ]: _('MARK READ'),
		[this.ACCEPT]: _('ACCEPT'),
		[this.REJECT]: _('REJECT'),
		[this.ADMIN]: _('MAKE ADMIN'),
		[this.MEMBER]: _('MAKE MEMBER')
	}

	static fromData(data, list) {
		let inst = new Notification(list);
		inst._id = data.id;
		inst._type = data.type;
		inst._user = data.user_id;
		inst._created_on = data.created_on;
		inst._action_on = data.actioned_on;
		inst._read_on = data.read_on;
		inst._msg = data.msg;
		inst._actionsArray = data.actions;
		
		return inst;
	}

	constructor(list){
		this._list = list;

		this._id = 0;
		this._type;
		this._user;
		this._created_on;
		this._action_on;
		this._read_on;
		this._msg;
		this._actionsArray;

		this._elem;
	}

	get elem() {
		if (this._elem == null) {
			this._elem = UI.div('notification-row', [
				UI.p('notification-message', this._msg),
				UI.p('notification-date', timeAgo(this._created_on)),
				this._actions = UI.div('notification-action-row', this.actions)
			]);
		}
		return this._elem;
	}

	get actions() {
		if (this._actionsArray.length && this._action_on == null) {
			return this._actionsArray.map(action => UI.btn(
				'',
				Notification.ACTION_LABELS[action],
				{
					'click': () => this.action(action)
				}
			));
		}
		if (this._read_on == null) {
			return UI.btn(
				'',
				Notification.ACTION_LABELS[Notification.READ],
				{
					'click': () => this.action(Notification.READ)
				}
			);
		}
		return null;
	}

	action(value) {
		API.fetch(
			`notifications/${this.id}/action/${value}`
		)
		.then(reply => {
			showError(reply);
			while (this._actions.firstChild) this._actions.removeChild(this._actions.firstChild);
			this._list.showCount(reply.notifications.count);
		})
	}

	get id() {return this._id}

	get type() {return this._type}
}